<ng-container *ngIf="block && block.length">
    <div *ngFor="let item of block; let idx = index;" class="{{classColumn}} paragraph">
        <h2 *ngIf="item.titolo" class="ls-h3-item-p-title w-100" [innerHTML]="item.titolo"></h2>
        <h3 *ngIf="item.sottotitolo_breve" class="ls-p-medium w-100" [innerHTML]="item.sottotitolo_breve"></h3>
        <div *ngIf="item.testo_formattato" [innerHTML]="helpersService.modifyLinks(item.testo_formattato, domainWebsite) | safeHtml"></div>
    </div>
</ng-container>